import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "related-project" }

import { ref, onMounted } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useInputColumn
} from 'xrk-components';
import { promotionContent } from '../data-source/apis';
import { formatter } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'add-relation',
  props: {
    hasForm: {},
    relationTableData: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
const xrkTableRef = ref();
const selectionRows = ref();
onMounted(() => {
  (props.relationTableData.value || []).forEach(item => {
    xrkTableRef.value.addSelectionRow(item.id, item);
  });
});
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索',
    beforeSearch(value) {
      selectionRows.value = xrkTableRef.value.getSelectionRows();
      return value;
    },
    afterSearch() {
      (selectionRows.value || []).forEach(item => {
        xrkTableRef.value.addSelectionRow(item.id, item);
      });
    }
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useInputColumn({
      prop: 'title',
      label: '',
      config: {
        type: 'text',
        placeholder: '请输入资讯名称',
        inputTextReplace: true,
        maxlength: 200
      }
    }),
    props.hasForm === 1 &&
      useInputColumn({
        prop: 'surveyCode',
        label: '',
        config: {
          type: 'text',
          placeholder: '请输入关联表单编号',
          inputTextReplace: true,
          maxlength: 200
        }
      })
  ].filter(Boolean),
  otherComponents: []
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      width: 120
    }),
    useTableColumn({
      type: 'index',
      label: '序号',
      width: 80
    }),
    useTableColumn({
      label: '编码ID',
      prop: 'infoCode'
    }),
    useTableColumn({
      label: '资讯标题',
      prop: 'title'
    }),
    useTableColumn({
      label: '作者',
      prop: 'author'
    }),
    props.hasForm === 1 &&
      useTableColumn({
        label: '关联表单编号',
        prop: 'surveyCode'
      }),
    useTableColumn({
      label: '更新时间',
      prop: 'updateAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    })
  ].filter(Boolean)
});

const getListAjax = async params => {
  try {
    const restParams = {
      ...params,
      hasForm: props?.hasForm
    };
    // 过滤掉值为空字符串的属性
    const filteredObj = Object.keys(restParams).reduce((acc, key) => {
      if (restParams[key] != null && restParams[key] !== '') {
        acc[key] = restParams[key];
      }
      return acc;
    }, {});

    const res = await promotionContent(filteredObj);
    return res;
  } catch (error) {
    console.log(error);
  }
};

__expose({
  getSelectionRows: () => {
    return xrkTableRef.value.getSelectionRows();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})